// @flow

import React, { type Node } from 'react';
import { useRedirect } from '@tectonics/hooks';
import { Empty } from '@tectonics/components';

type Props = {|
  url: string,
  delay: number,
|};

export function Redirect({ url, delay }: Props): Node {
  useRedirect(url, delay);
  return <Empty />;
}
